import { translateFn } from 'apps/webcomponents/src/utils/translator.helper';

export const LicenseMessageFn = {
  LICENSE_MESSAGE_PURCHASE_TOOLTIP: () => translateFn('This feature requires an additional add-on.'),
  LICENSE_UPGRADE_DISCLAIMER: (link?: string) =>
    translateFn('To unlock advanced compliance standards, a Compliance Manager add-on license is required. {LINK}', {
      LINK: link,
    }),
  LICENSE_FREE_TIER_LIMIT: (link?: string) =>
    translateFn(
      'Compliance posture is currently based on evaluating 1000 resources and their identities from your organization. To evaluate additional resources, a separate add-on is required. {LINK}',
      {
        LINK: link,
      }
    ),
  LICENSE_HARD_LIMIT: (link?: string) =>
    translateFn('The assessment limit of 100000 has been reached. Some resources may remain unassessed. {LINK}', {
      LINK: link,
    }),
  LICENSE_RESTRICTED_MESSAGE: () =>
    translateFn('You require a Compliance Manager add-on license to view this information.'),
  LICENSE_RESTRICTED_TITLE: () => translateFn('License required'),
  LEARN_MORE: () => translateFn('Learn more'),
  CONTACT_PARTNER: () => translateFn('Contact your partner'),
  CONTACT_SUPPORT: () => translateFn('Contact Technical Support'),
};

export const LicenseLink = {
  PRODUCT_HUB_LINK: '#!/in-product-trials/compliance-manager',
  MSP_LICENSE_LINK: 'https://bitdefender.com/en-us/business/products/gravityzone-compliance-manager',
  CONTACT_SUPPORT_LINK: 'https://www.bitdefender.com/business/support/en/71263-85158-contact.html',
};

export const RiskMessageFn = {
  RISK_NOT_FOUND_MESSAGE: () => translateFn('There are no risks associated with this control.'),
  RISK_NOT_FOUND_TITLE: () => translateFn('No risks found'),
  GO_TO_FINDING_PAGE: () => translateFn('Go to the Findings page and start a scan.'),
  NO_RISK_IDENTIFIED: () => translateFn('No risks identified.'),
  START_SCAN: () => translateFn('Start a scan to find risks'),
  NO_RESULTS: () => translateFn('No results were found'),
  NO_RESULTS_ADJUST_FILTER: () =>
    translateFn("Try adjusting your search or filter options to find what you're looking for."),
};

export const AssetsMessageFn = {
  ASSETS_NOT_FOUND_MESSAGE: () => translateFn('There are no assets associated with this control.'),
  ASSETS_NOT_FOUND_TITLE: () => translateFn('No assets found'),
};

export enum ComplianceDisclaimer {
  HARD_LIMIT = 'HARD_LIMIT',
  PURCHASE_ADD_ON = 'PURCHASE_ADD_ON',
  FREE_TIER_LIMIT = 'FREE_TIER_LIMIT',
}
